const LAST_NON_AUTH_PATH_STORAGE_KEY = "jr.lastNonAuthPath";
const LOGIN_REDIRECT_PATH_STORAGE_KEY = "jr.loginRedirectPath";

const AUTH_FLOW_PATHS = new Set([
    "/signin",
    "/signinpopup",
    "/callback",
    "/silentrenew",
    "/logout"
]);

const getStorage = () => {
    if (typeof window === "undefined") {
        return null;
    }

    return window.sessionStorage;
};

export const getRelativeUrl = (locationLike = window.location) => {
    const pathname = locationLike?.pathname || "/";
    const search = locationLike?.search || "";
    const hash = locationLike?.hash || "";

    return `${pathname}${search}${hash}`;
};

export const isAuthFlowPath = (path) => {
    if (!path || typeof path !== "string") {
        return true;
    }

    const pathname = path.startsWith("/")
        ? (path.split(/[?#]/, 1)[0] || "/")
        : path;

    return AUTH_FLOW_PATHS.has(pathname);
};

export const normalizeRedirectPath = (path) => {
    if (!path || typeof path !== "string" || !path.startsWith("/") || isAuthFlowPath(path)) {
        return "/";
    }

    return path;
};

export const rememberLastNonAuthPath = (path) => {
    if (isAuthFlowPath(path)) {
        return;
    }

    const storage = getStorage();
    if (!storage) {
        return;
    }

    storage.setItem(LAST_NON_AUTH_PATH_STORAGE_KEY, normalizeRedirectPath(path));
};

export const getLastNonAuthPath = () => {
    const storage = getStorage();
    if (!storage) {
        return "/";
    }

    return normalizeRedirectPath(storage.getItem(LAST_NON_AUTH_PATH_STORAGE_KEY));
};

export const rememberLoginRedirectPath = (path) => {
    const storage = getStorage();
    if (!storage) {
        return;
    }

    storage.setItem(LOGIN_REDIRECT_PATH_STORAGE_KEY, normalizeRedirectPath(path));
};

export const consumeLoginRedirectPath = () => {
    const storage = getStorage();
    if (!storage) {
        return "/";
    }

    const path = normalizeRedirectPath(storage.getItem(LOGIN_REDIRECT_PATH_STORAGE_KEY));
    storage.removeItem(LOGIN_REDIRECT_PATH_STORAGE_KEY);

    return path;
};
